import { useNavigate } from 'react-router';
import { getLang, handlePaymentScreenAction } from '../../../Helpers/functions';
import style from '../PaymentStatusScreen.module.css';

interface WidgetProps {
    widget : any
    paymentSecret : string
    cartId : string
    modelId : string
}

const Boost = ({widget,paymentSecret,cartId,modelId} : WidgetProps) => {
    const navigate = useNavigate();
    
    const handleNextAction = () => {
        if(widget.button.payload.url){
            window.location.href = widget.button.payload.url;
        }
    }

    return <div className="card border-0 shadow-sm mt-3 position-relative">
        <div className="card-body payment_success_card_radius " style={{background : widget.background}}>
            <div style={{fontSize : "16px"}}>
                <strong className='fw-bolder' style={{fontSize : "19px"}}>
                    {widget.header}
                </strong>
                <p style={{fontSize : "14px"}} className={`mt-1 ${style.addons_description}`}> 
                    {widget.description}
                </p>
                <button onClick={handleNextAction} className='btn fw-bold' style={{backgroundColor : widget.button.background, color : widget.button.textColor,maxWidth : "140px",minWidth : "140px"}}>
                    {widget.button.text}
                </button>
                <img className={`position-absolute bottom-0 ${getLang() == 'ar' ? 'start-0' : 'end-0'}`} height="95" src={widget.image.replace("{platform}","android").replace("{size}","h")}/>
            </div>
        </div>
    </div>
}

export default Boost;